module.exports = __webpack_public_path__ + "img/facebook.1d62ca66.png";